import { Button } from "antd";
import React, { useEffect, useState, useMemo } from "react";

import "./PackageList.scss";
import { ReactSVG } from "react-svg";

const PackageList = ({
  packages,
  editPack,
  addPack,
  removePack,
  hasWarehouses,
  addFromWarehouse
}) => {
  const [isValidPackages, setIsValidPackages] = useState(false);

  useEffect(() => {
    setIsValidPackages(packages?.filter((pack) => pack.quantity)?.length);
  }, [packages]);

  const { customPackages, inventoryPackages } = useMemo(() => {
    const custom = [];
    const inventory = [];
    packages?.forEach((pack) => {
      if (pack.inventoryItemId) {
        inventory.push(pack);
      } else {
        custom.push(pack);
      }
    });
    return { customPackages: custom, inventoryPackages: inventory };
  }, [packages]);

  const allPackages = useMemo(() => {
    return [...customPackages, ...inventoryPackages];
  }, [customPackages, inventoryPackages]);

  return (
    <div className="PackageList">
      <h1>PACKAGE</h1>
      {!isValidPackages && (
        <p className="ant-form-item-explain-error">At least 1 package</p>
      )}
      {allPackages?.map((pack, index) => {
        const isInventoryPack = !!pack.inventoryItemId;

        const groupedByItem = {};
        if (isInventoryPack && pack.inventoryItemSerials) {
          pack.inventoryItemSerials.forEach((serial) => {
            const key = serial.itemId || "unknown";
            if (!groupedByItem[key]) {
              groupedByItem[key] = {
                itemId: serial.itemId,
                itemName: serial.itemName,
                serials: []
              };
            }
            groupedByItem[key].serials.push(serial);
          });
        }

        return (
          <div className="package-item" key={pack.id || index}>
            <div className="top">
              <div className="content">
                {pack.action !== "new" && (
                  <>
                    {index + 1}. <b>{pack.type || pack.name} package</b>
                  </>
                )}
              </div>
              {!pack.action && (
                <div className="actions">
                  <Button type="link" className="edit" onClick={() => editPack(pack)}>
                    Edit
                  </Button>
                  <Button type="link" className="delete" onClick={() => removePack(pack)}>
                    Delete
                  </Button>
                </div>
              )}
            </div>
            <div className="bottom">
              {!pack.action && (
                <>
                  <p>
                    {pack.name} x {pack.quantity}
                  </p>
                  {isInventoryPack && pack.inventoryItemSerials?.length > 0 && (
                    <div style={{ marginTop: "8px" }}>
                      <p
                        style={{
                          fontSize: "11px",
                          color: "#1890ff",
                          marginBottom: "4px",
                          fontWeight: 500
                        }}
                      >
                        From: Warehouse
                      </p>
                      {Object.values(groupedByItem).map((itemGroup, groupIdx) => (
                        <div key={groupIdx} style={{ marginBottom: "16px" }}>
                          <p
                            style={{
                              fontSize: "12px",
                              fontWeight: 600,
                              margin: "8px 0 6px 0",
                              color: "#262626"
                            }}
                          >
                            {itemGroup.itemName} (ID: {itemGroup.itemId})
                          </p>
                          <table
                            style={{
                              fontSize: "12px",
                              width: "100%",
                              borderCollapse: "collapse",
                              border: "1px solid #e0e0e0",
                              borderRadius: "4px",
                              overflow: "hidden"
                            }}
                          >
                            <thead>
                              <tr style={{ backgroundColor: "#1f3998" }}>
                                <th
                                  style={{
                                    padding: "10px 12px",
                                    textAlign: "left",
                                    borderBottom: "none",
                                    fontWeight: 600,
                                    color: "#ffffff",
                                    fontSize: "13px"
                                  }}
                                >
                                  Serial
                                </th>
                                <th
                                  style={{
                                    padding: "10px 12px",
                                    textAlign: "left",
                                    borderBottom: "none",
                                    fontWeight: 600,
                                    color: "#ffffff",
                                    fontSize: "13px"
                                  }}
                                >
                                  Attribute
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              {itemGroup.serials.map((serial, idx) => (
                                <tr
                                  key={idx}
                                  style={{
                                    backgroundColor: idx % 2 === 0 ? "#ffffff" : "#f4f4f4"
                                  }}
                                >
                                  <td
                                    style={{
                                      padding: "10px 12px",
                                      borderBottom:
                                        idx === itemGroup.serials.length - 1
                                          ? "none"
                                          : "1px solid #e0e0e0",
                                      color: "#212121"
                                    }}
                                  >
                                    {serial.serialNumber}
                                  </td>
                                  <td
                                    style={{
                                      padding: "10px 12px",
                                      borderBottom:
                                        idx === itemGroup.serials.length - 1
                                          ? "none"
                                          : "1px solid #e0e0e0",
                                      color: "#212121"
                                    }}
                                  >
                                    {serial.itemAttribute || "-"}
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      ))}
                    </div>
                  )}
                </>
              )}
            </div>
          </div>
        );
      })}
      <div style={{ display: "flex", gap: "12px", flexWrap: "wrap" }}>
        <Button size="large" className="add-new-pack" onClick={() => addPack()}>
          Add More Packages
        </Button>
        {hasWarehouses && (
          <Button
            size="large"
            className="add-new-pack"
            style={{ backgroundColor: "#43c1c2", borderColor: "#43c1c2", color: "#fff" }}
            onClick={() => addFromWarehouse && addFromWarehouse()}
          >
            Add From Warehouse
          </Button>
        )}
      </div>
    </div>
  );
};
export default PackageList;
